<template>
  <div class="identify">
    <van-popup v-model="isShow"   round close-on-click-overlay @close="isShow=false">
      <div class="text-align-center padding-top24 paddingX21 relative">
        <div class="absolute right17 top17 font-size3 color-999" @click="isShow=false"><van-icon name="cross" /></div>
        <p class="margin-bottom12">请输入图形验证码</p>
        <div class="code-content padding-top30">
          <img class="width100 code-img inline-block float-left" :src="codeImgUrl"  style="height:58px;"/>
          <div @click="refreshCode" class="code-refresh float-left ">
            <img :src="refresh" alt="">
          </div>
        </div>
        <div style="clear: both"></div>
        <!-- isFocus=!isFocus -->
        <div class="margin-top24 margin-bottom20" >
          <div v-for="(item, index) of 3" :key="index" class="float-left margin-right8">
            <input disabled maxlength="1" v-model="code[index]" class="code-input border-radius4 font-size8" type="number"/>
          </div>
          <div class="float-left">
            <input disabled maxlength="1" v-model="code[3]" class="code-input border-radius8 font-size8" type="number"/>
          </div>
          <div style="clear: both"></div>
        </div>
        <!-- <input @input="checkCode" class="hidden" type="number" maxlength="4" v-model="code" :focus="isFocus" /> -->
      </div>
    </van-popup>
      <van-number-keyboard :z-index="3000" :show="isShow"  @blur="show = false" @input="checkCode" @delete="onDelete" />
  </div>
</template>

<script>
import refresh from '@/assets/images/refresh.png'
export default {
    props:{
        mobile:{
            type:String
        }
    },
  data () {
    return {
      isShow: false,
      code: [],
      refresh,
      codeImgUrl: '',
      length:4
    }
  },
  methods: {
    onDelete() {
      if (this.code.length > 0) {
        this.code.pop();
      }
    },
    checkCode (v) {
        if (this.code.length < this.length) {
            this.code.push(v);
        }
      let code =this.code
      if (code.length === 4) {
        this.$post({
          url:  this.$apis.smsSend,
          param: {
            phone: this.mobile,
            imgCode: this.code.join(''),
          },
          type: 'post'
        }).then(
          res => {
              if(res.code==0){
                  this.$toast('短信发送成功');
                  //this.$emit('identified', this.code)
                  this.isShow=false
              }else{
                this.refreshCode()
                // this.$toast(res.message);
              }
          }
        ).catch(()=>{
             this.refreshCode()
        })
      }
    },
    getImageUrl () {
      this.codeImgUrl = this.$apis.imagecode + '?phone=' + this.mobile + '&rondom=' + Math.random()
    },
    refreshCode () {
      if (!this.isShow) return
      this.getImageUrl()
      this.code = []
    }
  },
  watch: {
    isShow (v) {
      this.refreshCode()
    }
  }
}
</script>
<style lang="scss" scoped>
.identify {
  .hidden {
    width: 0;
    height: 0;
  }
  .code-input {
    width: 54px;
    height: 54px;
    background-color: #f6f6f6;
    border: #e2e2e2 1px solid;
    text-align: center;
  }
  .code-img {
    width: 195px;
    background-color: #f6f6f6;
  }
  .code-refresh {
    width: 52px;
    background-color: #f6f6f6;
    height:58px;

  }
  .code-content {
    width: 248px;
    height: 53px;
  }
  .get-code-btn {
    font-size: 13px;
    padding: 0 13px;
    border: #32AE57 1px solid !important;
  }
}
.van-popup--center.van-popup--round{
    border-radius:8px;
}
.van-popup--center{
    top:30%;
}
</style>
